// Gallery.jsx
import React, { useState, useEffect } from 'react';
import "./Gallery.css";
import NavDropdown from 'react-bootstrap/NavDropdown';
import GalleryData from "./GalleryData";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from 'react-router-dom';

const galleryData= {
    all:{"SweetPain":["SweetPain","30x40 acrylic on canvas"],
        "Elegance":["Elegance","30x30 acrylic on canvas"],
        "FeminineUrge":["Feminine Urge","50x70 acrylic on canvas with modeling paste"],
        "lostinlust1":["Lost in Lust","50x70 acrylic on canvas"],
        "blackWoman":["Woman In Black","50x70 acrylic on canvas with gold leaves"],
        "watercolorWoman3":["Watercolor woman","20x30cm watercolor on paper"],
        "acrylic_portrait":["Woman Portrait","40x50cm acrylic on canvas"],
        "watercolorAngryWoman":["Angry Face","20x30cm watercolor on paper"],
        "figures":["Figures","50x70 acrylic on canvas with modeling paste"],
        "watercolor_eye":["Watercolor Eye","20x30cm watercolor on paper"],
        "naked":["Naked","30x40cm acrylic on canvas"],
        "eye":["Eye","20x25cm acrylic on canvas"],
        "man":["Man","abstract man figure with hagiography powder colors"],
        "watercolorAngryEye":["Watercolor Angry Eye","30x40cm watecolor on paper"],
        "Silence1":["Silence","30x30cm acrylic on cavnas"],
        "2acrylicpaintings":["Figure","2x15x15cm acrylic on canvas with modeling paste"],
        "figuresLARGE":["Figures","50x70cm acrylic on canvas with modeling paste"],
        "nameafougkrazesai":["Να με αφουγκράζεσαι","50x70cm acrylic on canvas with modeling paste"],
        "womanWithScarf":["Woman With Scarf","40x60cm acrylic on canvas"],
        "watercolorWoman4":["Watercolor woman","20x30cm watercolor on paper"],
        "angel":["Angel","65x90cm acrylic on canvas"],
        "watercolorManCrying":["Watercolor Man Crying","30x40cm sketch with watercolor"],
        "womanSketch":["Woman Sketch","15x20cm sketch with pencil and charcoal"],
        "manWatercolor":["Watercolor man","20x30cm watercolor on paper"],
        "watercolorMan2":["Watercolor man","20x30cm watercolor on paper"],
        "watercolorWoman2":["Watercolor woman","20x30cm watercolor on paper"],
        "medusa":["Medusa","65x90cm acrylic on canvas with spatula effect and gold leaves"],
        "watercolorWoman5":["Watercolor woman","20x30cm watercolor on paper"],
        },
    acrylics:{"SweetPain":["SweetPain","30x40 acrylic on canvas"],
        "Elegance":["Elegance","30x30 acrylic on canvas"],
        "FeminineUrge":["Feminine Urge","50x70 acrylic on canvas with modeling paste"],
        "lostinlust1":["Lost in Lust","50x70 acrylic on canvas"],
        "blackWoman":["Woman In Black","50x70 acrylic on canvas with gold leaves"],
        "acrylic_portrait":["Woman Portrait","40x50cm acrylic on canvas"],
        "figures":["Figures","50x70 acrylic on canvas with modeling paste"],
        "naked":["Naked","30x40cm acrylic on canvas"],
        "eye":["Eye","20x25cm acrylic on canvas"],
        "man":["Man","abstract man figure with hagiography powder colors"],
        "Silence1":["Silence","30x30cm acrylic on cavnas"],
        "2acrylicpaintings":["Figure","2x15x15cm acrylic on canvas with modeling paste"],
        "nameafougkrazesai":["Να με αφουγκράζεσαι","50x70cm acrylic on canvas with modeling paste"],
        "figuresLARGE":["Figures","50x70cm acrylic on canvas with modeling paste"],
        "medusa":["Medusa","65x90cm acrylic on canvas with spatula effect and gold leaves"],
        "womanWithScarf":["Woman With Scarf","40x60cm acrylic on canvas"],
        "angel":["Angel","65x90cm acrylic on canvas"],
        "watercolorWoman5":["Watercolor woman","20x30cm watercolor on paper"],
        },
    watercolors:{
        "watercolorWoman3":["Watercolor woman","20x30cm watercolor on paper"],
        "watercolorAngryWoman":["Angry Face","20x30cm watercolor on paper"],
        "watercolor_eye":["Watercolor Eye","20x30cm watercolor on paper"],
        "watercolorAngryEye":["Watercolor Angry Eye","30x40cm watecolor on paper"],
        "watercolorManCrying":["Watercolor Man Crying","30x40cm sketch with watercolor"],
        "watercolorWoman4":["Watercolor woman","20x30cm watercolor on paper"],
        "watercolorWoman2":["Watercolor woman","20x30cm watercolor on paper"],
        "manWatercolor":["Watercolor man","20x30cm watercolor on paper"],
        "watercolorMan2":["Watercolor man","20x30cm watercolor on paper"],
         }, 
    sketches:{"womanSketch":["Woman Sketch","15x20cm sketch with pencil and charcoal"]}
}

const chunkArray = (arr, size) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

const Gallery = () => {
  const isMobileInit = window.innerWidth < 768;
  const [cols, setCols] = useState(isMobileInit ? 2 : 3);
  const [currentSet, setCurrentSet] = useState("all"); // "all" | "acrylics" | "watercolors" | "sketches"

  useEffect(() => {
    const onResize = () => setCols(window.innerWidth < 768 ? 2 : 3);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const keys = Object.keys(galleryData[currentSet]);
  const [images, setImages] = useState(chunkArray(keys, cols));
  const [dropdownTitle, setDropdownTitle] = useState("All");

  // re-chunk when cols or set changes
  useEffect(() => {
    setImages(chunkArray(Object.keys(galleryData[currentSet]), cols));
  }, [cols, currentSet]);

  const handleFilter = (setName, title) => {
    setCurrentSet(setName);
    setDropdownTitle(title);
    // images will be recomputed by the effect
  };

  return (
    <>
      <div className="">
        <div className="d-flex pt-5">
          <div className="headerContainer w-100">
            <div className="logoContainer">
              <h1 className="logo">KAIPI MARIA</h1>
            </div>
            <div className="d-flex menuBar">
              <Link to={"/"} className="nav-item nav-link" id="homeBtn">Home</Link>
              <Link to={"/Gallery"} className="nav-item nav-link active" id="Gallery" style={{ textDecoration: "underline" }}>Gallery</Link>
              <Link to={"/AboutMe"} className="nav-item nav-link" id="AboutMeBtn">AboutMe</Link>
              <Link to={"/Contact"} className="nav-item nav-link" id="ContactBtn">Contact</Link>
              <Link to={"/Shop"} className="nav-item nav-link" id="ShopBtn">Shop</Link>
            </div>
          </div>
        </div>

        <div className="row filter_row justify-content-end m-2"
             style={{ fontSize: "1.5rem", fontFamily: 'Times New Roman', textAlign: "end" }}>
          <NavDropdown id="dropdown-basic-button" align="end" title={dropdownTitle} menuVariant="light">
            <NavDropdown.Item onClick={() => handleFilter("all", "All")}
                              style={{ fontSize: "1.5rem", textAlign: "end" }}>
              All
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleFilter("acrylics", "Acrylics")}
                              style={{ fontSize: "1.5rem", textAlign: "end" }}>
              Acrylics
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleFilter("watercolors", "Watercolors")}
                              style={{ fontSize: "1.5rem", textAlign: "end" }}>
              Watercolors
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleFilter("sketches", "Sketches")}
                              style={{ fontSize: "1.5rem", textAlign: "end" }}>
              Sketches
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      </div>

      <div className="gallery mt-0">
        {/* IMPORTANT: pass the object for the current set */}
        <GalleryData renderImages={images} galleryData={galleryData[currentSet]} />
      </div>

      <div className="block-layout position-relative justify-content-center">
        <a href="https://www.instagram.com/kaipimaria_art/" className="socialIcons"><FaInstagram size={30} /></a>
        <a href="https://www.facebook.com/profile.php?id=100012918557813" className="socialIcons"><FaFacebook size={30} /></a>
        <a href="mailto:kaiphmaria001@gmail.com" className="socialIcons"><MdOutlineEmail size={30} /></a>
      </div>
    </>
  );
};

export default Gallery;
